<template>
  <span class="dmh-wrap">
    <b-button size="sm" variant="outline-secondary"
              title="How to use Compare Drivers" aria-label="Help" @click="show_help = true">
      <i class="fa fa-info-circle"></i>
    </b-button>

    <b-modal v-model="show_help" title="Using Compare Drivers" size="lg" ok-only scrollable>
      <div class="dmh-body">
        <h4>What this page is</h4>
        <p>
          Several drivers side by side on the same metrics, in the same order, over the same
          period. The Roster List ranks everyone on one column at a time; this holds a handful of
          people still and shows you every column at once.
        </p>

        <hr/>

        <h4>Reading a column</h4>
        <p>
          One driver per column, one metric per row, grouped into the same sections the Individual
          Driver page uses &mdash; so a metric sits in the same place on both pages.
        </p>
        <p>
          The <b>Fleet Average</b> column is the whole roster for the period, not an average of the
          drivers you picked. It is there so a column can be read against the fleet rather than
          only against whoever else you happened to select.
        </p>

        <hr/>

        <h4>What the colours mean</h4>
        <p>
          Each cell is coloured against your tenant&rsquo;s thresholds, not against the other
          columns. Two drivers can both be red, or the best of your selection can still be past the
          line &mdash; the comparison is with the standard you set, not with each other.
        </p>

        <hr/>

        <h4>Comparing fairly</h4>
        <p>
          Rate metrics (per 10k miles, percentages) are already mileage-adjusted, so a part-timer
          and a full-timer can be read against each other directly. <b>Raw totals</b> &mdash; miles,
          idle hours, DVIR counts &mdash; cannot: a driver with twice the mileage will have more of
          nearly everything. Check the mileage row before drawing a conclusion from a total.
        </p>
        <p>
          <b>Insufficient Data</b> drivers are shown but not ranked. Too few miles or bus days in
          the period to score fairly.
        </p>

        <hr/>

        <h4>The date range</h4>
        <p>
          Scores are published in periods of about five days, each one five days after it ends,
          once your telematics provider's review window has closed. The range ends on the latest
          published period, so it never includes days that are still settling: a half-finished
          period would read as a drop in mileage. The <b>1m</b>, <b>3m</b>, <b>6m</b> and
          <b>12m</b> chips count back from there, and the date pickers show exactly the days being
          scored.
        </p>
      </div>
    </b-modal>
  </span>
</template>

<script>
export default {
  name: 'driver_manager_compare_help',
  data() {
    return { show_help: false }
  },
}
</script>

<style scoped>
.dmh-body h4 { font-size: 1.05rem; margin-top: 4px; }
.dmh-body p, .dmh-body li { font-size: 0.95rem; }
.dmh-body li { margin-bottom: 6px; }
</style>
